import { cancelPayment, trackBackButton } from 'actions';
import { NOOP } from 'constants/actions';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import type { RootState } from 'reducers/types';
import { isCouponAdded } from 'selectors';
import { useTranslations } from 'utils/translations/useTranslations';
import { ReactComponent as BackIcon } from './assets/ico-arrow-back.svg';

import './BackButton.scss';

const BackButtonComponent = ({
  trackBackButton = NOOP,
  cancelPayment = NOOP,
  onClick = NOOP,
  isCouponAdded = false,
}) => {
  const i18n = useTranslations();

  function handleClick() {
    if (!isCouponAdded) {
      cancelPayment();
    }
    trackBackButton();
    onClick();
  }

  return (
    <button
      className="Instructions-back"
      onClick={handleClick}
      data-testid="back-button"
    >
      <BackIcon />
      {i18n.t('checkout.instructions.back')}
    </button>
  );
};

BackButtonComponent.propTypes = {
  cancelPayment: PropTypes.func,
  onClick: PropTypes.func,
  trackBackButton: PropTypes.func,
};

const mapStateToProps = (state: RootState) => ({
  isCouponAdded: isCouponAdded(state),
});

const BackButton = connect(mapStateToProps, { trackBackButton, cancelPayment })(
  BackButtonComponent,
);

export { BackButton, BackButtonComponent };
